import { remove } from 'lodash';
import React from 'react';
import ImageUpload from '../../components/imageUpload'
import useMycustomerForm from '../myCustomersComponents/useMycustomerForm';
const _ = require('lodash');
const CustomerProfile2 = (props) => {
    const { errors } = useMycustomerForm(props.personalData, props.index)
    if (_.find(props.personalData, ["PropName", "No. of Entrepreneurs (Men)"])) {
        sessionStorage.setItem("value1", _.find(props.personalData, ["PropName", "No. of Entrepreneurs (Men)"]).PropValue)
    }
    if (_.find(props.personalData, ["PropName", "No. of Entrepreneurs (Women)"])) {
        sessionStorage.setItem("value2", _.find(props.personalData, ["PropName", "No. of Entrepreneurs (Women)"]).PropValue)
    }
    const onTypeValueChange = (value, index) => {
        props.personalData[index].PropValue = value
        sessionStorage.setItem("dropdownCustomerType",value)
        if (value === "SWP") {
            removeObj("No. of Entrepreneurs (Men)")
            removeObj("No. of Entrepreneurs (Women)")
        } else {
            addObj(10, "No. of Entrepreneurs (Men)", sessionStorage.getItem('value1'))
            addObj(11, "No. of Entrepreneurs (Women)", sessionStorage.getItem('value2'))
        }
        props.onChange(props.personalData)
    }
    const onValueChange = (e, index) => {
        props.personalData[index].PropValue = e.target.value
        // isErrorExist()
        props.onChange(props.personalData)
    }
    const removeObj = (PropName) => {
        _.map(props.personalData, (personalData, innerIndex) => {
            if (personalData && personalData.PropName === PropName) {
                props.personalData.splice(innerIndex, 1)
            }
        })
    }

    const addObj = (position, name, value) => {
        if (_.find(props.personalData, ['PropName', name]) === undefined) {
            props.personalData.splice(position, 0, { PropName: name, PropValue: value, units: "" })
        }
    }
    const onChangeImage = (e, img) => {
        if (img === "") {
            _.find(props.personalData, ["PropName", "Photo"]).PropValue = "data:image/png;base64,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"
        } else {
            _.find(props.personalData, ["PropName", "Photo"]).PropValue = img
        }
        props.onChange(props.personalData)
    }
    const renderClass = (data, index) => {
        if (errors[index].PropName === data.PropName && errors[index].PropMsg) {
            return "se-form-control " + errors[index].PropClass
        } else {
            return "se-form-control"
        }
    }
    const renderError = (data, index) => {
        if (errors[index].PropName === data.PropName && errors[index].PropMsg) {
            return <span className="se-error-text" style={{ float: "left" }}>
                {errors[index].PropMsg}
            </span>
        }
    }
    const renderPhotoError = (data, index) => {
        if (_.find(errors, ['PropName', "Photo"]).PropName === data.PropName && _.find(errors, ['PropName', "Photo"]).PropMsg) {
            return <span className="se-error-text" style={{ float: "left", display: "tableCaption", width: "10vw" }}>
                {_.find(errors, ['PropName', "Photo"]).PropMsg}
            </span>
        }
    }
    const renderForm = _.map(props.personalData, (data, index) => {
        if (data.PropName === "Customer Type") {
            return <div class="row" align="right">
                <label className="col-sm-6 se-label">{data.PropName}<span class="se-mandatory">*</span></label>
                <div className="col-md-5">
                    <select style={{ width: "100%" }} disabled={sessionStorage.getItem('UserType') !== "End User"}
                        value={data.PropValue} className={sessionStorage.getItem('UserType') !== "End User" ? "customerProfileSelect" : "se-form-control"}
                        onChange={(e) => onTypeValueChange(e.target.value, index)}>
                        <option value="Agro">Agro</option>
                        <option value="SWP">SWP</option>
                    </select>
                </div>
            </div>
        } else {
            if (data.PropName !== "Photo") {
                return <div class="row pt-3" align="right">
                    <label className="col-sm-6 se-label">{data.PropName}<span class="se-mandatory">*</span></label>
                    <div className="col-md-5">
                        <input onChange={(e) => onValueChange(e, index)} style={{ width: "100%" }} type="text" className={renderClass(data, index)}
                            value={data.PropValue} autoComplete="off"
                        />
                        {renderError(data, index)}
                    </div>

                </div>
            }
        }
    })
    React.useEffect(() => {
        props.onChange(props.personalData)
    }, [props.personalData])
    React.useEffect(() => {
        props.isError(errors)
    }, [errors])
    React.useEffect(() => {
        onTypeValueChange(sessionStorage.getItem("customerType"), 0)
    }, [])

    return <se-block display="grid">
        <div className="rows" align="right">
            <div className="col-sm-9 col-md-9 col-lg-9 col-xl-9 se-white-background " align="left">
                {renderForm}
            </div>
            <div class="text-left">
                <div class="text-center bg-light">
                    <ImageUpload onChangeImage={onChangeImage}
                        photo={_.find(props.personalData, ['PropName', "Photo"]).PropValue} />
                    {renderPhotoError(_.find(props.personalData, ['PropName', "Photo"]))}
                </div>
                {props.disabledIcon || props.disabled ? null :
                    <div style={{ position: "absolute", right: "0px", top: "0px" }}>
                        <se-icon size="small" class="pointer" onClick={() => props.close("dialog-Popup")}>action_delete_cross</se-icon>
                    </div>}
            </div>
        </div>
    </se-block>
}
export default CustomerProfile2